(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-read-more]').forEach(function(el) {
      var id = el.getAttribute('data-read-more');
      var btn = document.getElementById('btn-' + id);
      if (!btn) return;
      var parrafos = el.querySelectorAll('p');
      if (parrafos.length <= 1) {
        btn.style.display = 'none';
      } else {
        el.classList.add('collapsed');
      }
      btn.addEventListener('click', function() {
        el.classList.toggle('collapsed');
        btn.textContent = el.classList.contains('collapsed') ? 'Leer más' : 'Leer menos';
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
